import _slicedToArray from "/home/runner/work/PBS-Gatsby/PBS-Gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useMemo, useCallback } from 'react';
import autoAnimate from '../index.mjs';

/**
 * AutoAnimate hook for adding dead-simple transitions and animations to react.
 * @param options - Auto animate options or a plugin
 * @returns
 */
function useAutoAnimate(options) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    controller = _useState2[0],
    setController = _useState2[1];
  var memoizedOptions = useMemo(function () {
    return options;
  }, []);
  var element = useCallback(function (node) {
    if (node instanceof HTMLElement) {
      setController(autoAnimate(node, memoizedOptions));
    } else {
      setController(undefined);
    }
  }, [memoizedOptions]);
  var setEnabled = useCallback(function (enabled) {
    if (controller) {
      enabled ? controller.enable() : controller.disable();
    }
  }, [controller]);
  return [element, setEnabled];
}
export { useAutoAnimate };